export const method = 'post';

export default {
    access_token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczpcL1wvY291cmllci5xbGljXC9hcGlcL2xvZ2luIiwiaWF0IjoxNTg1MjcwODM5LCJuYmYiOjE1ODUyNzA4MzksImp0aSI6IkJ0VkdnTmZkZjQxRFdsOUUiLCJzdWIiOjEsInBydiI6IjIzYmQ1Yzg5NDlmNjAwYWRiMzllNzAxYzQwMDg3MmRiN2E1OTc2ZjcifQ.ooLYhOl3eahv-C2c8hAO32Ot8xW5VG74RJR9Y9Gabcw',
    token_type: 'bearer',
    expires_in: 0,
};